module.exports = __webpack_public_path__ + "static/media/logo.963a5e0c.png";